import { filledArrowDownDataUri } from 'components/Icon/filledArrowDownDataUri';
import styled from 'styled-components';
import { halfStep } from 'tokens';

// The wrapper is used because <select> elements are very difficult to style. The intention is that
// the <select> will grow as large as it needs to be in order to contain its items, but never get
// bigger than 100% of its parent. You would expect to be able to acheive that with max-width: 100%,
// but that doesn't work with <select>s.
type WrapperProps = {
	maxWidth?: number;
	fullWidth: boolean;
};
export const Wrapper = styled.div<WrapperProps>`
	width: ${(p) => (p.fullWidth ? '100%' : 'auto')};
	max-width: ${(p) => (p.maxWidth === undefined ? '100%' : p.maxWidth + 'px')};
`;

export const Select = styled.select`
	font-size: 11px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	background-color: ${({ theme }) => theme.gray[100]};
	display: block;
	box-sizing: border-box;
	width: 100%;
	height: 20px;

	// Wipe out the native select styling and build up our own
	appearance: none;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	padding: 2px ${halfStep}px;
	border-radius: 2px;

	// Arrow on right end
	padding-right: 20px; // Make room for the triangle
	background-image: url('data:image/svg+xml;utf8,${({ theme }) =>
		encodeURIComponent(filledArrowDownDataUri(theme.gray[1000]))}');
	background-repeat: no-repeat;
	background-position: top 40% right 2px;
	background-size: 16px auto;

	// Show ellipsis if text is too long
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.gray[600]};
	}

	&:disabled {
		opacity: 0.5;
	}
`;
